import { create } from 'zustand';

/** Запись в истории терминала */
export interface TerminalHistoryEntry {
  id: string;
  type: 'input' | 'output' | 'error' | 'success';
  content: string;
  timestamp: number;
}

interface TerminalStore {
  // State
  history: TerminalHistoryEntry[];
  commandHistory: string[];
  historyIndex: number;

  // Actions
  addEntry: (entry: Omit<TerminalHistoryEntry, 'id' | 'timestamp'>) => void;
  addToCommandHistory: (command: string) => void;
  setHistoryIndex: (index: number) => void;
  clearHistory: () => void;

  // Getters
  getLastCommand: () => string | undefined;
  getPreviousCommand: (currentIndex: number) => string | undefined;
  getNextCommand: (currentIndex: number) => string | undefined;
}

/** Генерация уникального ID */
function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/**
 * Zustand store для состояния терминала
 */
export const useTerminalStore = create<TerminalStore>((set, get) => ({
  history: [],
  commandHistory: [],
  historyIndex: -1,

  addEntry: (entry) => {
    set((state) => ({
      history: [
        ...state.history,
        {
          ...entry,
          id: generateId(),
          timestamp: Date.now(),
        },
      ],
    }));
  },

  addToCommandHistory: (command) => {
    set((state) => ({
      commandHistory: [...state.commandHistory, command],
      historyIndex: -1,
    }));
  },

  setHistoryIndex: (index) => {
    set({ historyIndex: index });
  },

  clearHistory: () => {
    set({ history: [], commandHistory: [], historyIndex: -1 });
  },

  getLastCommand: () => {
    const { commandHistory } = get();
    return commandHistory[commandHistory.length - 1];
  },

  getPreviousCommand: (currentIndex) => {
    const { commandHistory } = get();
    const newIndex = currentIndex + 1;
    if (newIndex >= commandHistory.length) return undefined;
    return commandHistory[commandHistory.length - 1 - newIndex];
  },

  getNextCommand: (currentIndex) => {
    const { commandHistory } = get();
    if (currentIndex <= 0) return undefined;
    return commandHistory[commandHistory.length - currentIndex];
  },
}));
